import type { Variant } from './Experience';

export enum TripType {
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
  COMPLEX = 'COMPLEX',
}

export enum StepType {
  SEGMENT = 'SEGMENT',
  CONNECTION = 'CONNECTION',
}

/**
 * Trip: A group of sequential segment/connection steps following each other within a 24h interval and reprensenting a travel trip
 */
export interface Trip<TProduct> {
  date: string;
  steps: Array<Step<TProduct>>;
}

/**
 * Step: A significant date or duration in your experience with products associated with it.
 */
export interface Step<TProduct> {
  departureDateTime: string;
  durationInMinutes: number;
  stepType: StepType;
  products: Array<TProduct>;
}

export interface RoundTripBundleByUpgradeType {
  upgradeType: string;
  canOfferRoundTrip: boolean;
  outboundTrip?: Variant;
  returnTrip?: Variant;
}

/**
 * Journey: Details about the beginning and the end of your `IExperience`.
 */

export interface Journey {
  tripType: TripType;
  multiCity: boolean;
  departureDate: string;
  returnDate?: string;
  backgroundImage: string;
  originCode: string;
  originName: string;
  destinationCode: string;
  destinationName: string;
  roundTripBundleByUpgradeTypeList?: Array<RoundTripBundleByUpgradeType>;
}
